import { jsx as _jsx } from "react/jsx-runtime";
import { SquareSpan } from './IconContainer.styled';
export const IconContainer = ({ children }) => _jsx(SquareSpan, { children: children });
